// 领券中心
export default [
	{
		path: '/coupon-center',
		name: 'CouponCenter',
		component: () => import('@/views/couponCenter/index.vue'),
		meta: { title: '领券中心', whiteListed: true }
	}
]
